import { createFileRoute } from "@tanstack/react-router";
import { FestivalPage, buildHomeHead } from "@/components/festival/Page";

export const Route = createFileRoute("/en")({
  head: () => buildHomeHead("en"),
  component: () => <FestivalPage lang="en" />,
});